export default {"src":"/_next/static/media/Register-icon.092ac45f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};